import * as api from '../lib/api';

export function sendPrescriptions(growerId, type, zipFilename, prescriptions) {
  return api.post(`/growers/${growerId}/deere/prescriptions/${type}`, {
    zipFilename,
    prescriptions: prescriptions.map(
      ({ fieldName, validationErrors, fieldId, year, name, ...prescription }) =>
        prescription,
    ),
  });
}

export function getPartners() {
  return api.get(`/deere/partners`).then((partners) =>
    partners.map((partner) => ({
      ...partner,
      display: `${partner.name} (${partner.id})`,
    })),
  );
}

export async function getUnconnectedPartners() {
  const partners = await getPartners();
  return partners.filter((p) => !p.isConnected);
}

export function disconnect(grower) {
  return api.destroy(`/growers/${grower.guid}/deere/organizations`);
}

export function connect(grower, organizationId) {
  return api
    .post(`/growers/${grower.guid}/deere/organizations/${organizationId}`)
    .then(redirectChecker);
}

export function authenticate() {
  return get(`/organizations`);
}

export function getUser() {
  return get(`/user`);
}

export function get(path) {
  return api.get(`/deere${path}`).then(redirectChecker);
}

export function getAccessTokens() {
  return api.get(`/admin/deere/access-tokens`);
}

export function deleteAccessToken(id) {
  return api.destroy(`/admin/deere/access-tokens/${id}`);
}

export function getSubscriptions() {
  return api.get(`/admin/deere/subscriptions`);
}

export function deleteSubscription(id) {
  return api.destroy(`/admin/deere/subscriptions/${id}`);
}

export async function getGrowerOrganization(growerId) {
  const organizations = await api.get(
    `/growers/${growerId}/deere/organizations`,
  );
  return organizations.length ? organizations[0] : [];
}

export function getOrganizationFields(growerId, organizationId) {
  return api.get(
    `growers/${growerId}/deere/organizations/${organizationId}/fields`,
  );
}

export function getOrganizationOperations(growerId, organizationId) {
  return api.get(
    `growers/${growerId}/deere/organizations/${organizationId}/operations`,
  );
}

export function processOperations(ids, growerId) {
  return api.post(`growers/${growerId}/deere/operations/process`, {
    ids,
    growerId,
  });
}
export function uploadUncertified(growerId, fieldProperties) {
  return api.post(`${growerId}/boundaries`, fieldProperties);
}

async function redirectChecker(response) {
  if (!response?.redirect) return response;
  window.location = response.redirect;
  await new Promise(() => {});
}
